import { render, staticRenderFns } from "./m-dialog-conversation-chip-recent-shipments.vue?vue&type=template&id=9ecad634&scoped=true&"
import script from "./m-dialog-conversation-chip-recent-shipments.vue?vue&type=script&lang=js&"
export * from "./m-dialog-conversation-chip-recent-shipments.vue?vue&type=script&lang=js&"
import style0 from "./m-dialog-conversation-chip-recent-shipments.vue?vue&type=style&index=0&id=9ecad634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecad634",
  null
  
)

export default component.exports